import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
// import { authReducer } from '../features/auth/authSlice';
import {
  PurchaseOrdersApi,
  rolesApi,
  transactionsApi,
  uomApi,
  usersApi,
  workOrdersApi,
} from '../api';
import { accountsApi } from '../api/accountsApi';
import { afesApi } from '../api/afesApi';
import { clientsApi } from '../api/clientsApi';
import { invoicesApi } from '../api/invoicesApi';
import { loginApi } from '../api/loginApi';
import { authReducer } from './authSlice';
import { ToastrMiddleware } from './toastr-middleware';

export const store = configureStore({
  reducer: {
    [transactionsApi.reducerPath]: transactionsApi.reducer,
    counter: counterReducer,
    auth: authReducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [invoicesApi.reducerPath]: invoicesApi.reducer,
    [afesApi.reducerPath]: afesApi.reducer,
    [workOrdersApi.reducerPath]: workOrdersApi.reducer,
    [PurchaseOrdersApi.reducerPath]: PurchaseOrdersApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [uomApi.reducerPath]: uomApi.reducer,
    // [searchApi.reducerPath]: searchApi.reducer,
    // [detailApi.reducerPath]: detailApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(transactionsApi.middleware)
      .concat(loginApi.middleware)
      .concat(accountsApi.middleware)
      .concat(invoicesApi.middleware)
      .concat(afesApi.middleware)
      .concat(workOrdersApi.middleware)
      .concat(PurchaseOrdersApi.middleware)
      .concat(clientsApi.middleware)
      .concat(usersApi.middleware)
      .concat(rolesApi.middleware)
      .concat(uomApi.middleware)
      .concat(ToastrMiddleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
